var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-registry-add.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"isPending") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"isSuccess");
frame.set("registryPending", t_1, true);
if(frame.topLevel) {
context.setVariable("registryPending", t_1);
}
if(frame.topLevel) {
context.addExport("registryPending", t_1);
}
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"isSuccess") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"isPending");
frame.set("registrySuccess", t_2, true);
if(frame.topLevel) {
context.setVariable("registrySuccess", t_2);
}
if(frame.topLevel) {
context.addExport("registrySuccess", t_2);
}
if(runtime.contextOrFrameLookup(context, frame, "registryPending")) {
var t_3;
t_3 = "is-pending";
frame.set("pendingOrSuccessClass", t_3, true);
if(frame.topLevel) {
context.setVariable("pendingOrSuccessClass", t_3);
}
if(frame.topLevel) {
context.addExport("pendingOrSuccessClass", t_3);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "registrySuccess")) {
var t_4;
t_4 = "is-success";
frame.set("pendingOrSuccessClass", t_4, true);
if(frame.topLevel) {
context.setVariable("pendingOrSuccessClass", t_4);
}
if(frame.topLevel) {
context.addExport("pendingOrSuccessClass", t_4);
}
;
}
;
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productRegistry")),"showProductRegistries") && (lineno = 9, colno = 58, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["registry.registries"])) && (lineno = 9, colno = 90, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["registry.meta.count",0])) > 0) {
var t_5;
t_5 = "is-open";
frame.set("hasRegistriesClass", t_5, true);
if(frame.topLevel) {
context.setVariable("hasRegistriesClass", t_5);
}
if(frame.topLevel) {
context.addExport("hasRegistriesClass", t_5);
}
;
}
var t_6;
t_6 = (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isMarketPlace")?"is-disabled":"");
frame.set("disabledClass", t_6, true);
if(frame.topLevel) {
context.setVariable("disabledClass", t_6);
}
if(frame.topLevel) {
context.addExport("disabledClass", t_6);
}
var t_7;
t_7 = (runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")?"family | add to registry click":"add to registry click");
frame.set("registryEventCategory", t_7, true);
if(frame.topLevel) {
context.setVariable("registryEventCategory", t_7);
}
if(frame.topLevel) {
context.addExport("registryEventCategory", t_7);
}
output += "<div class=\"dom-add-to-registry\">\n\n    <li class=\"g-sku-action__link c-product-add-links__li\">\n\n        <a href=\"#\"\n            class=\"c-product-add-links__a c-product-add-to-registry__a ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "hasRegistriesClass"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "pendingOrSuccessClass"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabledClass"), env.opts.autoescape);
output += " js-create-registry-ui\"\n            ";
output += runtime.suppressValue((lineno = 22, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE",runtime.contextOrFrameLookup(context, frame, "registryEventCategory"),(lineno = 22, colno = 56, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.displayName"]))])), env.opts.autoescape);
output += "\n            data-qa-add-to-registry=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "registrySuccess"), env.opts.autoescape);
output += ">\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "registryPending")) {
output += "<span class=\"c-product-add-links__text\">\n                    <span class=\"c-product-add-links__circle\"></span>\n                    <span class=\"c-product-add-links__circle\"></span>\n                    <span class=\"c-product-add-links__circle\"></span>\n                </span>\n\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "registrySuccess")) {
output += runtime.suppressValue((lineno = 40, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-added-to-registry"])), env.opts.autoescape);
output += "\n\n            ";
;
}
else {
output += runtime.suppressValue((lineno = 45, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-add-to-registry"])), env.opts.autoescape);
;
}
;
}
output += "\n\n        </a>\n\n    </li>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-registry-add.j2"] , dependencies)